import { render, staticRenderFns } from "./KimsaUploadFile.vue?vue&type=template&id=66c62f37&scoped=true"
import script from "./KimsaUploadFile.vue?vue&type=script&lang=js"
export * from "./KimsaUploadFile.vue?vue&type=script&lang=js"
import style0 from "./KimsaUploadFile.vue?vue&type=style&index=0&id=66c62f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c62f37",
  null
  
)

export default component.exports